import { useState } from 'react';
import { useBulkActionsState } from 'src/components/common/BulkActions/useBulkActionsState';
import { useInventoryEventBulkActionsState } from 'src/components/Events/EventListing/InventoryEventListing/BulkActions/InventoryEventBulkActions/useInventoryEventBulkActionsState';
import { useBulkEditListingGroupSettings } from 'src/components/Listings/InventoryActionDropdown/components/BulkEditListingGroupSettingsAction';
import { useBulkGroupListings } from 'src/components/Listings/InventoryActionDropdown/components/GroupListingsAction/useBulkGroupListings';
import { useBulkMoveToGroup } from 'src/components/Listings/InventoryActionDropdown/components/GroupListingsAction/useBulkMoveToGroup';
import { useBulkUngroupListings } from 'src/components/Listings/InventoryActionDropdown/components/LaunchUngroupListingsAction';
import { Content } from 'src/contexts/ContentContext';
import { PosDropdown } from 'src/core/POS/PosDropdown';
import { vars } from 'src/core/themes';
import { Button } from 'src/core/ui';
import { ChevronDownIcon, IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { EventWithData } from 'src/WebApiController';

interface GroupActionsProps {
  data: EventWithData;
}

export const GroupActions = ({ data }: GroupActionsProps) => {
  const { areBulkActionsEnabled } = useBulkActionsState();

  const [isLoading, setIsLoading] = useState(false);

  const { filterQueryWithEventIds } = useInventoryEventBulkActionsState(
    data.event
  );

  const bulkGroupListings = useBulkGroupListings(data.event);

  const bulkMoveToGroup = useBulkMoveToGroup(data);

  const bulkUngroupListings = useBulkUngroupListings(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    data.event
  );

  const bulkEditListingGroupSettings = useBulkEditListingGroupSettings(
    filterQueryWithEventIds,
    data,
    setIsLoading,
    isLoading
  );

  return (
    <>
      <PosDropdown
        key="event-pricing-actions-dropdown"
        trigger={
          <Button variant="outline">
            <Content id={ContentId.Group} />
            <ChevronDownIcon
              size={vars.iconSize.xs}
              fill={IconsFill.currentColor}
            />
          </Button>
        }
        align="start"
        triggerProps={{ disabled: isLoading || !areBulkActionsEnabled }}
      >
        {bulkEditListingGroupSettings.dropDown}
        {bulkGroupListings.dropdown}
        {bulkMoveToGroup.dropdown}
        {bulkUngroupListings.dropDown}
      </PosDropdown>
    </>
  );
};
